import StoredLayout from '../../layouts/StoredLayout'
import Badges from './Badges'
export default StoredLayout(Badges)
